import { DefaultModel } from "../../framework/default.model";
import { CfgIntegracaoEventoChave } from "./cfg-integracao-evento-chave.enum";
import { CfgIntegracaoEventoCliente } from "./cfg-integracao-evento-cliente.model";

export class CfgIntegracaoEvento extends DefaultModel {

  idCfgIntegracaoGrupoFuncao: number;
  
  nome: string;
  
  chave: CfgIntegracaoEventoChave;

  cfgIntegracaoEventosCliente: CfgIntegracaoEventoCliente[];

}